// extracted by mini-css-extract-plugin
export default {"commit-hash":"CommitHash_commit-hash__rtvxv"};